import { CLIENTS_ROUTE, PROSPECTS_ROUTE } from '../../../shared/constants/auth';
import type { IQuoteFlowReturnTarget } from '../../../shared/hooks/useQuoteActions/useQuoteActions';
import type { IProspect } from '../../../shared/interfaces/prospects';
import { TRANSLATIONS_CLIENTS } from '../../../shared/translations/clients';
import { TRANSLATIONS_QUOTES } from '../../../shared/translations/quotes';

export interface IBreadcrumbItem {
  label: string;
  onClick?: () => void;
}

interface IBuildCreateQuoteBreadcrumbParams {
  prospect: IProspect | null;
  isEditing: boolean;
  fromClient: boolean;
  returnTo: IQuoteFlowReturnTarget | null;
  t: (key: string) => string;
  onRequestLeave: (target: string) => void;
}

export const buildCreateQuoteBreadcrumb = ({
  prospect,
  isEditing,
  fromClient,
  returnTo,
  t,
  onRequestLeave
}: IBuildCreateQuoteBreadcrumbParams): IBreadcrumbItem[] => {
  const backRoute = fromClient ? CLIENTS_ROUTE : PROSPECTS_ROUTE;
  const backLabel = fromClient ? t(TRANSLATIONS_CLIENTS.title) : t(TRANSLATIONS_QUOTES.create.breadcrumbBack);
  const companyProfileRoute = fromClient && returnTo ? returnTo.path : `${PROSPECTS_ROUTE}/${prospect?.id}`;

  return [
    { label: backLabel, onClick: () => onRequestLeave(backRoute) },
    ...(prospect ? [{ label: prospect.companyName, onClick: () => onRequestLeave(companyProfileRoute) }] : []),
    { label: isEditing ? t(TRANSLATIONS_QUOTES.create.editQuote) : t(TRANSLATIONS_QUOTES.create.newQuote) }
  ];
};
